import React, { Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuAppBar from '../menuapp/MenuAppBar';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  root: {
    width: '100%',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100%',
    overflow: 'auto',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
});

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false, verDetalhes: false };
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true, error: error, info: info.componentStack ? info.componentStack : JSON.stringify(info) });
  }

  componentWillUnmount () {
    this.state = { hasError: false, verDetalhes: false };
  }

  handleExibir = () => {
    this.setState({ verDetalhes: !this.state.verDetalhes });
  }

  handleClick = () => {
    this.setState({ hasError: false });
  }

  render () {
    const { classes, history } = this.props;

    if (this.state.hasError) {
      return (
        <Fragment>
          <MenuAppBar />
          <div className={classes.root}>
            <div className={classes.content}>
              <div className={classes.appBarSpacer} />
              <Typography variant='headline' gutterBottom>
                Ocorreu um erro. Tente novamente ou entre em contato com o suporte.
              </Typography>
              <Link to={history.location} className={classes.link}>
                <Button className={classes.button} onClick={this.handleClick}>
                  Retornar
                </Button>
              </Link>
              <Button className={classes.button} onClick={this.handleExibir}>
                Ver detalhes
              </Button>
              { this.state.verDetalhes &&
                <TextField
                  disabled
                  multiline
                  fullWidth
                  style={{ margin: 8 }}
                  label='Erro'
                  defaultValue={this.state.info}
                  className={classes.textField}
                  margin='normal'
                />
              }
            </div>
          </div>
        </Fragment>
      );
    }
    return this.props.children;
  }
}

export default withStyles(styles)(ErrorBoundary);
